import React, {useEffect} from 'react';
import Common from "./common";
import store from "../../storeWire";
import {setData} from "../../store/slice/customerLedgerMemo";
import axios from "axios";
import Helper from "../../application/helper";
import {usePage} from "@inertiajs/inertia-react";
import {
    CButton,
    CButtonGroup,
    CCard,
    CCardBody, CCardFooter,
    CCardText,
    CCardTitle,
    CCol, CContainer, CFormCheck,
    CFormFloating,
    CFormInput,
    CFormLabel, CFormTextarea, CInputGroup, CInputGroupText,
    CRow
} from "@coreui/react";

const Destroy = () => {
    const p = usePage();
    useEffect(() => {
        axios.get(Helper.route('customerledgermemo.show', {
            customerledgermemo: p.props.customer_ledger_memo
        })).then((res) => {
            if (res.data.data.id !== undefined && res.data.data.id) {
                store.dispatch(setData(res.data.data));
            } else {
                window.location.href = Helper.route('customer-ledger-memo.index');
            }
        }).catch(() => {
            window.location.href = Helper.route('customer-ledger-memo.index');
        });
    }, []);
    return <>
        <CContainer fluid={true}>
            <CRow>
                <CCard className={'card text-white bg-danger'}>
                    <CCardBody>
                        <CCardTitle>Destroy Ledger Memo</CCardTitle>
                        <CCardText>
                            Press Destroy to remove this ledger memo, Remember this is non reversible Operation.
                        </CCardText>
                    </CCardBody>
                </CCard>
            </CRow>
        </CContainer>
        <Common/></>;
}

export default Destroy;
